export default __webpack_public_path__ + "static/media/BLR-2.5b8044e9.JPG";